<template>
  <div class="fiche">
    <h4 class="mb-3 infos-title">Caractéristiques principales</h4>
    <hr class="mx-0 mb-2" />
    <p v-if="eoliennesConstructeurs.length === 1">
      Constructeur des éoliennes : <i>{{ eoliennesConstructeurs[0] }}</i>
    </p>
    <div v-else-if="eoliennesConstructeurs.length > 1">
      <p>
        Constructeurs des éoliennes :
        <span v-for="(constructeur, index) in eoliennesConstructeurs" :key="index">
          <span v-if="index !== 0">, </span><i>{{ constructeur }}</i>
        </span>
      </p>
    </div>
    <p>
      Nombre d'éoliennes :
      <i v-if="parc.nombreAerogenerateur">{{ parc.nombreAerogenerateur }}</i>
      <i v-else class="empty-field">{{ emptyField }}</i>
    </p>
    <p>
      Nombre de postes de livraison :
      <i v-if="parc.nombrePosteLivraison">{{ parc.nombrePosteLivraison }}</i>
      <i v-else class="empty-field">{{ emptyField }}</i>
    </p>
    <p v-if="eoliennesMaxHauteur">
      Hauteur de bout de pale : <i>{{ eoliennesMaxHauteur }} m</i>
    </p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'CharacteristicsSection',
  computed: {
    ...mapGetters({
      parc: "parc",
      eoliennesConstructeurs: "eoliennesConstructeurs",
      eoliennesMaxHauteur: "eoliennesMaxHauteur"
    })
  },
  data() {
    return {
      emptyField: 'Non renseigné'
    }
  }
}
</script>
